import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./pages/Home/Home";
import Header from "./components/header/Header";
import Auth from "./pages/Auth/Auth";
import Profile from "./pages/profile/Profile";
import AiChecker from "./pages/AiChecker/AiChecker";
import Plagiarism from "./pages/Plagiarism/Plagiarism";
import Summarize from "./pages/Summarize/Summarize";
import Humanize from "./pages/Humanize/Humanize";
import Optimize from "./pages/Optimize/Optimize";
import { useState, useEffect } from "react";
import BoxLoader from "./components/Loader/BoxLoader";

function App() {
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        // Set loading to true when the route changes
        setLoading(true);

        // Simulate loading delay (you can replace this with actual data fetching logic)
        const timer = setTimeout(() => {
            // Set loading back to false after the delay
            setLoading(false);
        }, 900);

        // Clean up the timer to avoid memory leaks
        return () => clearTimeout(timer);
    }, [location.pathname]);
    return (
        <>
            {!loading && <Header />}
            <Routes>
                <Route
                    path="/"
                    element={
                        loading ? <BoxLoader loading={loading} /> : <Home />
                    }
                />
                <Route
                    path="/auth"
                    element={
                        loading ? <BoxLoader loading={loading} /> : <Auth />
                    }
                />
                <Route
                    path="/profile"
                    element={
                        loading ? <BoxLoader loading={loading} /> : <Profile />
                    }
                />
                <Route
                    path="/aichecker"
                    element={
                        loading ? (
                            <BoxLoader loading={loading} />
                        ) : (
                            <AiChecker />
                        )
                    }
                />
                <Route
                    path="/plagiarism"
                    element={
                        loading ? (
                            <BoxLoader loading={loading} />
                        ) : (
                            <Plagiarism />
                        )
                    }
                />
                <Route
                    path="/summarize"
                    element={
                        loading ? (
                            <BoxLoader loading={loading} />
                        ) : (
                            <Summarize />
                        )
                    }
                />
                <Route
                    path="/humanize"
                    element={
                        loading ? <BoxLoader loading={loading} /> : <Humanize />
                    }
                />
                <Route
                    path="/optimize"
                    element={
                        loading ? <BoxLoader loading={loading} /> : <Optimize />
                    }
                />
            </Routes>
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </>
    );
}

export default App;
